/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_No_Other_FoldersInputs */

const en_mobile_no_other_folders = /** @type {(inputs: Mobile_No_Other_FoldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No other folders to move to.`)
};

const es_mobile_no_other_folders = /** @type {(inputs: Mobile_No_Other_FoldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay otras carpetas a donde mover.`)
};

/**
* | output |
* | --- |
* | "No other folders to move to." |
*
* @param {Mobile_No_Other_FoldersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_no_other_folders = /** @type {((inputs?: Mobile_No_Other_FoldersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_No_Other_FoldersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_no_other_folders(inputs)
	return en_mobile_no_other_folders(inputs)
});